import {
  IModalControlButton, ModalControl, IModalControlButtonData
} from './index'
import {AvailableIcons} from "@/components/lib/models";

export class ModalControlButton implements IModalControlButton {
  readonly type: ModalControl
  readonly primary: boolean
  readonly row: boolean
  readonly label: string
  readonly icon?: AvailableIcons
  readonly id: string;
  handler: Function

  constructor(data?: IModalControlButtonData) {
    this.type = data?.type || 'ok';
    this.id = data?.id || this.type;
    this.label = data?.label || this.type;
    let primary = data?.primary;
    this.primary = (primary === undefined) ? true : primary;
    this.row = !!data?.row;
    this.icon = data?.icon;
    this.handler = data?.handler || new Function();
  }
}
